import axios from "axios";
import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// NewUser page components
import FormField from "components/FormField";

import { URL_API } from "config";
import { toast, ToastContainer } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, CircularProgress } from "@mui/material";
import { CrudUserContext } from "context/CrudUserContext";

export default function UserInfo({ formData }) {
  const { uuid } = useParams();

  let tag = localStorage.getItem("Tag");

  const [companyResult, setCompanyResult] = useState([]);
  const [companySearched, setCompanySearched] = useState();
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const { formField, values, errors, touched } = formData;
  const { name, email } = formField;
  let { name: nameV, email: emailV, company: companyV } = values;
  const { setInputCompany } = useContext(CrudUserContext);

  useEffect(() => {
    getSearchCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getSearchCompanies() {
    await axios
      // eslint-disable-next-line no-useless-concat
      .get(URL_API + "/companies?page=1&limit=500", {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then((response) => {
        response.data.data.sort((a, b) => {
          const nameA = a.name?.toLowerCase();
          const nameB = b.name?.toLowerCase();

          if (nameA < nameB) return -1;

          if (nameA > nameB) return 1;

          return 0;
        });

        response.data.data.unshift({ name: "Administrador" });

        setCompanyResult(response.data.data);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  const getTokenToResetPassword = async () => {
    try {
      setloading(true);

      const url = await axios.get(`${URL_API}/users/${uuid}/token-password`, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      });

      const copyToClipboard = () => {
        const input = document.createElement("input");
        input.value = url.data.url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        toast.success("URL copiado para a área de transferência!");
      };

      copyToClipboard();

      setloading(false);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("Tag");
        navigate("/auth/login");
      } else {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  return (
    <>
      <MDBox>
        <MDBox lineHeight={0}>
          <MDTypography variant="h5">Sobre o usuário</MDTypography>
          <MDTypography variant="button" color="text">
            Informações obrigatórias
          </MDTypography>
        </MDBox>

        <MDBox mt={1.625}>
          <FormField
            type={name.type}
            label={name.label}
            name={name.name}
            value={nameV}
            placeholder={name.placeholder}
            error={errors.name && touched.name}
            success={
              nameV?.length > 0 && !errors.name && /^[a-zA-Z]+$/.test(nameV)
            }
          />

          <FormField
            type={email.type}
            label={email.label}
            name={email.name}
            value={emailV}
            disabled={uuid}
            placeholder={email.placeholder}
            error={errors.email && touched.email}
            success={emailV?.length > 0 && !errors.email}
          />

          <Autocomplete
            value={
              companySearched
                ? companySearched
                : companyV
                ? { name: companyV }
                : { name: "Administrador" }
            }
            onChange={(event, newValue) => {
              setCompanySearched(newValue);
              setInputCompany(newValue);
            }}
            getOptionLabel={(comp) => comp?.name ?? "Administrador"}
            options={companyResult}
            disabled={uuid}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Selecione a Companhia"
              />
            )}
          />

          <MDBox sx={{ marginY: "2rem" }}>
            <MDButton
              variant="gradient"
              color="info"
              onClick={() => getTokenToResetPassword()}
            >
              {loading ? (
                <CircularProgress color="white" size="1rem" />
              ) : (
                "Link para resetar senha"
              )}
            </MDButton>
            <br />

            <MDTypography ml={1} variant="caption">link expira em 1h</MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>

      <ToastContainer />
    </>
  );
}

// typechecking props for UserInfo
UserInfo.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};
